import Objectives from './Objectives';

export default Objectives;


// WEBPACK FOOTER //
// /src/components/intro/pages/about/objectives/index.js